import type { KeyboardEventHandler, KeyboardEvent } from 'react';

export type KeyEventHandler = {
    onEnter?: (e: KeyboardEvent<{}>) => void;
    onEsc?: (e: KeyboardEvent<{}>) => void;
    onTab?: (e: KeyboardEvent<{}>) => void;
    onSpace?: (e: KeyboardEvent<{}>) => void;
    onArrowDown?: (e: KeyboardEvent<{}>) => void;
    onArrowUp?: (e: KeyboardEvent<{}>) => void;
    onArrowLeft?: (e: KeyboardEvent<{}>) => void;
    onArrowRight?: (e: KeyboardEvent<{}>) => void;
    onHome?: (e: KeyboardEvent<{}>) => void;
    onEnd?: (e: KeyboardEvent<{}>) => void;
    onPageDown?: (e: KeyboardEvent<{}>) => void;
    onPageUp?: (e: KeyboardEvent<{}>) => void;
    onDelete?: (e: KeyboardEvent<{}>) => void;
};
export function handleKey(
    handler: KeyEventHandler,
    preventDefault: boolean = true,
    preventShiftKeyWithTab = false
): KeyboardEventHandler<any> {
    return (e: KeyboardEvent<{}>) => {
        if (e.defaultPrevented) {
            return; // Should do nothing if the default action has been cancelled
        }

        let shouldPreventDefault = false;

        switch (e.key) {
            case 'Enter':
                if (handler.onEnter) {
                    handler.onEnter(e);
                    shouldPreventDefault = true;
                }
                break;
            case 'Delete':
                if (handler.onDelete) {
                    handler.onDelete(e);
                    shouldPreventDefault = true;
                }
                break;
            case ' ':
                if (handler.onSpace) {
                    handler.onSpace(e);
                    shouldPreventDefault = true;
                }
                break;
            case 'Escape':
                if (handler.onEsc) {
                    handler.onEsc(e);
                    shouldPreventDefault = true;
                }
                break;
            case 'Tab':
                if (handler.onTab && (!e.shiftKey || !preventShiftKeyWithTab)) {
                    handler.onTab(e);
                    shouldPreventDefault = true;
                }
                break;
            case 'ArrowDown':
                if (handler.onArrowDown) {
                    handler.onArrowDown(e);
                    shouldPreventDefault = true;
                }
                break;
            case 'ArrowUp':
                if (handler.onArrowUp) {
                    handler.onArrowUp(e);
                    shouldPreventDefault = true;
                }
                break;
            case 'ArrowLeft':
                if (handler.onArrowLeft) {
                    handler.onArrowLeft(e);
                    shouldPreventDefault = true;
                }
                break;
            case 'ArrowRight':
                if (handler.onArrowRight) {
                    handler.onArrowRight(e);
                    shouldPreventDefault = true;
                }
                break;
            case 'Home':
                if (handler.onHome) {
                    handler.onHome(e);
                    shouldPreventDefault = true;
                }
                break;
            case 'End':
                if (handler.onEnd) {
                    handler.onEnd(e);
                    shouldPreventDefault = true;
                }
                break;
            case 'PageDown':
                if (handler.onPageDown) {
                    handler.onPageDown(e);
                    shouldPreventDefault = true;
                }
                break;
            case 'PageUp':
                if (handler.onPageUp) {
                    handler.onPageUp(e);
                    shouldPreventDefault = true;
                }
                break;
            default:
                return;
        }

        if (preventDefault && shouldPreventDefault) {
            e.preventDefault();
        }
    };
}
